<script>
    import CreateUserComponent from "./CreateUserComponent.svelte";
    import {getContext} from "svelte";
    import EditUserComponent from "./ManageUser/EditUserComponent.svelte";

    const { open } = getContext('simple-modal');
    export let model_root;

    let users = loadUsers();

    function openNewUserPanel() {
        open(CreateUserComponent, {
            model_root: model_root
        }, {}, {
            onClosed: () => {
                // Optional: Liste neu laden nach Schließen
                users = loadUsers();
            }
        });
    }

    // --- NEUE FUNKTION ---
    function openEditUserPanel(user) {
        open(EditUserComponent, {
            model_root: model_root,
            user: user
        }, {
            // Styling für das Modal etwas anpassen falls nötig
            styleWindow: { background: '#ffffff', padding: '20px', minWidth: '500px' },
        }, {
            onClosed: () => {
                users = loadUsers(); // Liste aktualisieren nach Bearbeitung
            }
        });
    }
    // ---------------------

    function loadUsers() {
        return fetch(model_root + 'admin/user_management/get_users.php', {
            method: "GET"
        })
            .then(response => response.json());
    }

</script>

<table class="table table-hover table-responsive">
    <thead>
    <tr>
        <th scope="col">Nachname</th>
        <th scope="col">Vorname</th>
        <th scope="col">E-Mail Addresse</th>
        <th scope="col">Status</th> </tr>
    </thead>
    <tbody>
    {#await users}
        <p class="text-center mt-4 mb-4"><i class="fas fa-circle-notch fa-spin"></i> Nutzer werden geladen...</p>
    {:then data}
        {#each data as user}
            <tr role="button" on:click={() => openEditUserPanel(user)}>
                <td>{@html user.uname}</td>
                <td>{@html user.uprename}</td>
                <td>{user.umail}</td>
                <td>
                    {#if (user.uhashvaliduntil) && (new Date(Date.parse(user.uhashvaliduntil.replace(/-/g, '/')))) < (new Date())}
                        <span class="text-danger"><i class="far fa-bell me-2"></i>Link abgelaufen</span>

                    {:else if user.ulastlogin === null}
                        <span class="text-warning"><i class="far fa-envelope me-2"></i>Wartet auf Registrierung</span>

                    {:else if user.uhashvaliduntil}
                        <span class="text-info"><i class="fas fa-undo me-2"></i>Passwort-Reset</span>

                    {:else}
                        <span class="text-success"><i class="fas fa-check me-2"></i>Aktiv</span>
                    {/if}
                </td>
            </tr>
        {/each}
    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}
    </tbody>
</table>

<button class="btn btn-light mt-3" on:click={openNewUserPanel}>
    <i class="fas fa-plus"></i> Neuen Nutzer anlegen
</button>
